import request from '@/config/axios'
import type { AuditPageParams, AuditTrackPageParams } from './types'

export const getLoginLogList = (data: AuditPageParams): Promise<IResponse> => {
  return request.post({ url: '/admin/audit/login/list', data })
}

export const getLoginLogDetail = (data: { id: number | string }): Promise<IResponse> => {
  return request.post({ url: '/admin/audit/login/detail', data })
}

export const getOperationLogList = (data: AuditPageParams): Promise<IResponse> => {
  return request.post({ url: '/admin/audit/operation/list', data })
}

export const getExportAuditList = (data: AuditPageParams): Promise<IResponse> => {
  return request.post({ url: '/admin/audit/export/list', data })
}

export const getEmployeeLoginSummary = (data: Partial<AuditPageParams>): Promise<IResponse> => {
  return request.post({ url: '/admin/audit/employee/login-summary', data })
}

export const trackAuditPage = (data: AuditTrackPageParams): Promise<IResponse> => {
  return request.post({ url: '/admin/audit/track/page', data })
}
